module.exports = __webpack_public_path__ + "static/media/carlos-sanchez-mato_IU.aa942687.png";